import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const Modal = ({
  isOpen, content, onClose, closable = true,
}) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && closable) {
        onClose()
      }
    }

    if (isOpen) {
      document.body.style.overflow = 'hidden'
      document.addEventListener('keydown', handleEscKey)
    }

    return () => {
      document.body.style.overflow = 'unset'
      document.removeEventListener('keydown', handleEscKey)
    }
  }, [isOpen, onClose, closable])

  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && closable) {
      onClose()
    }
  }

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div className="backdrop" onClick={handleBackdropClick}>
      <div className="modal">
        {closable && (
          <button
            type="button"
            onClick={onClose}
            className="close-button"
            aria-label="Close modal"
          >
            ×
          </button>
        )}

        <div className="content">
          {content}
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  closable: PropTypes.bool,
}

Modal.defaultProps = {
  closable: true,
  content: 'No content provided',
}

export default Modal
